import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";
import type { ActivityPage } from "./use-activity";

/**
 * Head of the brand's activity feed (newest single event). Polled every 60s
 * (spec §3) — drives the topbar bell's unseen-dot.
 */
export function useActivityHead(brandId: string | null | undefined) {
  return useQuery({
    queryKey: ["activity-head", brandId],
    queryFn: () => apiFetch<ActivityPage>(`/brands/${brandId}/activity?limit=1`),
    enabled: !!brandId,
    staleTime: 60_000,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
}
